import React, { useMemo } from 'react';
import PropTypes, { oneOfType } from 'prop-types';

import { connect } from 'react-redux';

import AddTask from './add';
import CopyTask from './copy';
import Task from './task';
import withDragDropContext from 'helpers/react_dnd/with_drag_drop_context';

import { camelCase } from 'lodash';
import { getPlaybookTasks, isDealPlaybook } from '../helpers';

import './styles.scss';

export function PlaybookTasks({ canRequirePlaybookTasks, playbook, playbooks, recordType, stage, status }) {
  const target = isDealPlaybook(playbook) ? stage : status;
  const hasTasks = useMemo(() => {
    return Object.values(playbooks).some((playbook) => {
      return Object.values(getPlaybookTasks(playbook)).some(tasks => tasks && tasks.length > 0);
    });
  }, [playbooks]);

  return (
    <div className="playbook-tasks">
      <p>Create the following <b>{recordType} tasks:</b></p>

      <div className="table-container mb-3">
        <table className="table align-vertical">
          <thead>
            <tr>
              <th width="0" />
              <th>Name</th>
              {canRequirePlaybookTasks && <th>Required</th>}
              <th>Attachment</th>
              <th>Assignee</th>
              <th>Due Dates</th>
              <th width="0" />
            </tr>
          </thead>

          <tbody>
            {getPlaybookTasks(playbook)[camelCase(target.key)].map(task => (
              <Task canRequirePlaybookTasks={canRequirePlaybookTasks} key={task.name} playbook={playbook} task={task} />
            ))}
          </tbody>
        </table>
      </div>

      <AddTask playbook={playbook} stage={stage} status={status} />
      {hasTasks && <CopyTask />}
    </div>
  );
}

const playbookPropTypes = oneOfType([
  PropTypes.shape({
    tasksByStage: PropTypes.object.isRequired,
  }),
  PropTypes.shape({
    tasksByStatus: PropTypes.object.isRequired,
  }),
]).isRequired;

PlaybookTasks.propTypes = {
  canRequirePlaybookTasks: PropTypes.bool,
  playbook: playbookPropTypes,
  playbooks: PropTypes.arrayOf(playbookPropTypes).isRequired,
  recordType: PropTypes.string.isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
  status: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  canRequirePlaybookTasks: state.canRequirePlaybookTasks,
  recordType: state.playbookRecordType,
});

export default connect(mapStateToProps)(withDragDropContext(PlaybookTasks));
